import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=82bede2c&scoped=true&"
import script from "./OrderModal.vue?vue&type=script&lang=ts&"
export * from "./OrderModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=82bede2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bede2c",
  null
  
)

export default component.exports